import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchData } from "../../utils";
import { setNotification } from "../notificationsSlice";
import { has, toLower } from "lodash";
import { SHC_UPLOAD } from "../../settings";
import { schemas } from '../schemas';


export const getUploadDetails = createAsyncThunk(
    "getUploadDetails",
    async(uploadRef, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(SHC_UPLOAD, {
                headers: { "X-Upload-Ref": toLower(uploadRef) }
            }, schemas.SHC_UPLOAD);
            if (has(response, "entities") && has(response.entities, "shc")) {
                return response.entities.shc[toLower(uploadRef)];
            };
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue({ code: e.code });
        };
        return rejectWithValue({});
    }
);